import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/wxkf4.jpg'
import _imports_1 from '../assets/wxkf6.jpg'
import _imports_2 from '../assets/wxkf3.png'


const _withScopeId = n => (_pushScopeId("data-v-382e5640"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0.24rem 0.45rem","text-align":"center"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "联系电话：18925295283", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "微信号：sz5283", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  alt: "",
  style: {"width":"100%"}
}
const _hoisted_7 = {
  key: 2,
  src: _imports_1,
  alt: "",
  style: {"width":"100%"}
}
const _hoisted_8 = {
  key: 3,
  src: _imports_2,
  alt: "",
  style: {"width":"100%"}
}

import { getChannelCodeFromCache } from "@/utils/channelCode";

import { ref } from "vue";
import { Dialog } from "vant";

const __default__ = {
  name: "CustomerService",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: boolean;
}

const channelCode = ref<any>(getChannelCodeFromCache());





const handleConfirm = () => {
  window.location.href = "https://work.weixin.qq.com/kfid/kfc5b4dcd05b76e2af4";
  emit("update:modelValue", false);
};

const handleCancel = () => {
  emit("update:modelValue", false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog).Component, {
    show: props.modelValue,
    title: channelCode.value === 'LD0008' ?'官方客服': '官方企微客服',
    confirmButtonText: "在线客服",
    "show-cancel-button": "",
    showConfirmButton: false,
    confirmButtonColor: "#386BF6",
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    "get-container": "body"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (channelCode.value === 'LD0008')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
          : (channelCode.value === 'Lvxingshe3HZY')
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : (channelCode.value === 'Lvxingshe6HZY')
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : (_openBlock(), _createElementBlock("img", _hoisted_8))
      ])
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})